import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadApplicantAllSuccessful,
  loadApplicantAllFailed, loadApplicantAllBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';
import { getExistFields } from '../../../utils/utils';

export default function* loadApplicantListAll(action) {
  try {
    const { payload = {} } = action;
    const {
      filter,
    } = payload;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = { ...pool, ...getExistFields(filter) };
    }
    yield put(loadApplicantAllBegin());
    const url = `${BACKEND_URL_V2}/dict/applicants/all`;

    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadApplicantAllSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadApplicantAllFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadApplicantAllFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
